(function () {
  var storageKey = 'bloomingful:email-products:v1';
  var maxProducts = 12;

  function readItems() {
    try {
      var value = JSON.parse(window.localStorage.getItem(storageKey));
      return Array.isArray(value) ? value.slice(0, maxProducts) : [];
    } catch (error) { return []; }
  }

  function writeItems(items) {
    try { window.localStorage.setItem(storageKey, JSON.stringify(items.slice(0, maxProducts))); } catch (error) {}
  }

  function currentProduct(button) {
    return {
      title: button.getAttribute('data-product-title') || document.title,
      url: button.getAttribute('data-product-url') || window.location.href,
      image: button.getAttribute('data-product-image') || ''
    };
  }

  function addCurrent(button) {
    var items = readItems();
    var product = currentProduct(button);
    var existing = items.findIndex(function (item) { return item.url === product.url; });
    if (existing >= 0) items[existing] = product;
    else if (items.length < maxProducts) items.push(product);
    writeItems(items);
    return items;
  }

  function openModal(button) {
    var modal = document.querySelector('[data-bf-email-share-modal]');
    if (!modal) return;
    addCurrent(button);
    render(modal);
    modal.hidden = false;
    document.documentElement.classList.add('bf-email-share-open');
    var close = modal.querySelector('.bf-email-share__close');
    if (close) close.focus();
  }

  function closeModal(modal) {
    modal.hidden = true;
    document.documentElement.classList.remove('bf-email-share-open');
  }

  function render(modal) {
    var items = readItems();
    var list = modal.querySelector('[data-bf-email-share-list]');
    var status = modal.querySelector('[data-bf-email-share-status]');
    list.textContent = '';
    items.forEach(function (item, index) {
      var row = document.createElement('div');
      row.className = 'bf-email-share__item';
      if (item.image) {
        var image = document.createElement('img');
        image.src = item.image;
        image.alt = '';
        image.loading = 'lazy';
        row.appendChild(image);
      }
      var copy = document.createElement('div');
      var title = document.createElement('strong');
      title.textContent = item.title;
      var link = document.createElement('span');
      link.textContent = item.url.replace(/^https?:\/\/(www\.)?bloomingful\.com/i, 'bloomingful.com');
      copy.appendChild(title);
      copy.appendChild(link);
      row.appendChild(copy);
      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'bf-email-share__remove';
      remove.setAttribute('aria-label', 'Remove ' + item.title);
      remove.dataset.index = String(index);
      remove.textContent = 'x';
      row.appendChild(remove);
      list.appendChild(row);
    });
    status.textContent = items.length + (items.length === 1 ? ' product selected' : ' products selected');
    modal.querySelector('[data-bf-email-share-send]').disabled = items.length === 0;
    modal.querySelector('[data-bf-email-share-clear]').disabled = items.length === 0;
  }

  function sendEmail(modal) {
    var items = readItems();
    if (!items.length) return;
    var lines = ['Here are the Bloomingful products I wanted to share:', ''];
    items.forEach(function (item, index) { lines.push((index + 1) + '. ' + item.title); lines.push(item.url); lines.push(''); });
    window.location.href = 'mailto:?subject=' + encodeURIComponent('Bloomingful product selections') + '&body=' + encodeURIComponent(lines.join('\n'));
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-bf-email-product]');
    if (trigger) { event.preventDefault(); openModal(trigger); return; }
    var modal = event.target.closest('[data-bf-email-share-modal]');
    if (!modal) return;
    if (event.target.closest('[data-bf-email-share-close]')) { closeModal(modal); return; }
    var remove = event.target.closest('.bf-email-share__remove');
    if (remove) {
      var items = readItems();
      items.splice(Number(remove.dataset.index), 1);
      writeItems(items);
      render(modal);
      return;
    }
    if (event.target.closest('[data-bf-email-share-clear]')) { writeItems([]); render(modal); return; }
    if (event.target.closest('[data-bf-email-share-send]')) sendEmail(modal);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var modal = document.querySelector('[data-bf-email-share-modal]:not([hidden])');
    if (modal) closeModal(modal);
  });
}());
